<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="piv"></a> First Mariner Books edition 2003</p>
<p class="timebreak"> <br/></p>
<p class="center">Copyright © 2002 by Carol Anshaw<br/>
All rights reserved</p>
<p class="timebreak"> <br/></p>
<p class="center">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="timebreak"> <br/></p>
<p class="center"><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<p class="timebreak"> <br/></p>
<p class="center"><em>The Library of Congress has cataloged the print edition as follows:</em></p>
<p class="center">Anshaw, Carol.<br/>
Lucky in the corner / Carol Anshaw.<br/>
p. cm.<br/>
<span style="font-size: smaller">ISBN</span> 0-395-94040-0<br/>
<span style="font-size: smaller">ISBN</span> 0-618-34070-x (pbk.)</p>
<p class="center">1. Mothers and daughters—Fiction. 2. Lesbian mothers—Fiction. I. Title.</p>
<p class="center"><span style="font-size: smaller">PS</span>3551.<span style="font-size: smaller">N</span>7147 <span style="font-size: smaller">L</span>83 2002<br/>
813'.54—dc21 2001051891</p>
<p class="timebreak"> <br/></p>
<p class="center">e<span style="font-size: smaller">ISBN</span> 978-0-544-03203-3<br/>
v2.0514</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?1136734f